import axios from '@/utils/request';

// 列表
export const getList = (params) => {
  return axios.get('/system/role/listPage', { params })
}

// 添加
export const add = (data) => {
  return axios.post('/system/role/roleAdd', { ...data })
}

// 编辑
export const edit = (data) => {
  return axios.post('/system/role/roleUpdate', { ...data })
}

// 删除
export const delRole = (id) => {
  return axios.delete(`/system/role/${id}`)
}

// 获取菜单树
export const roleInfoFromUserId = () => {
  return axios.get(`/system/menu/list`)
}

// 获取角色详情
export const getRoleInfo = (params) => {
  return axios.get(`/system/role/roleInfo`, { params })
}

// 列表
export const getUserList = (params) => {
  return axios.get('/system/user/list', { params })
}